import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Devices from '../../../containers/devices/Devices';
import Signature from "@int/signature/lib/Main";
import DeleteAccount from "../../delete-account/DeleteAccount";
import Welcome from "./Welcome";
import Account from "../../account/Account";
import Billing from "../../billing/Billing";
import SharedEmails from '../../shared-emails/SharedEmails';
import Settings from '../../settings/Settings';
import Profile from '../../profile/Profile'
import Subscription from '../../subscription/Subscription'
import Avatars from '../../avatar/Avatars';

const AppRoutes = () => (
  <Switch>
      <Route exact path="/" component={Signature}/>
      <Route path="/account" component={Account}/>
      <Route path="/delete-account" component={DeleteAccount}/>
      <Route path="/billing" component={Billing}/>
      <Route path="/devices" component={Devices}/>
      <Route path="/signature" component={Signature}/>
      <Route path="/shared-emails" component={SharedEmails}/>
      <Route path="/settings" component={Settings}/>
      <Route path="/profile" component={Profile} />
      <Route path="/avatar" component={Avatars} />
      <Route path="/subscription" component={Subscription} />
      <Route render={() => <div>404 Page Not Found</div>}/>
  </Switch>
);

export default AppRoutes



// WEBPACK FOOTER //
// ./src/containers/app/components/AppRoutes.js